module.exports = __webpack_public_path__ + "static/media/bg-auth.fbc29b52.svg";